// extracted by mini-css-extract-plugin
module.exports = {"app":"style_app__3zVPM"};